import { myConst, myFn } from "@config/";

const { $$ } = myFn;


export const loadingEnd = () => {
    setTimeout(() => {
        $$("#loading").on(myConst.animationEvent, () => {
            $$("#loading").remove();
        });
        $$("#loading").addClass("over");
        $$("body").addClass("enter");
    }, 1);
};
